import { render, staticRenderFns } from "./AGBPage.vue?vue&type=template&id=f31467f6&scoped=true&"
import script from "./AGBPage.vue?vue&type=script&lang=js&"
export * from "./AGBPage.vue?vue&type=script&lang=js&"
import style0 from "./AGBPage.vue?vue&type=style&index=0&id=f31467f6&prod&lang=scss&scoped=true&"
import style1 from "./AGBPage.vue?vue&type=style&index=1&id=f31467f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31467f6",
  null
  
)

export default component.exports